<p class="mb-3">
  Il ticket non ha un asset collegato. Come vuoi procedere con la sostituzione?
</p>

<div class="flex flex-column gap-3 mb-3">
  <div class="flex align-items-start gap-2">
    <p-radioButton
      inputId="rwa_create"
      value="create"
      [formControl]="mode"></p-radioButton>
    <label
      for="rwa_create"
      class="cursor-pointer">
      <strong>Crea l'asset da sostituire</strong>
      <small class="block grey-text">
        L'asset viene creato con cliente e commessa del ticket e resta collegato al ticket. Se esiste
        già lo stesso seriale per lo stesso prodotto, cliente e commessa, viene riutilizzato.
      </small>
    </label>
  </div>
  <div class="flex align-items-start gap-2">
    <p-radioButton
      inputId="rwa_without"
      value="without"
      [formControl]="mode"></p-radioButton>
    <label
      for="rwa_without"
      class="cursor-pointer">
      <strong>Procedi senza asset</strong>
      <small class="block grey-text">
        Il ticket resta senza asset. Al rientro del dispositivo sostituito potrai collegarlo al
        ticket e alla sostituzione.
      </small>
    </label>
  </div>
</div>

<div
  *ngIf="mode.value === 'create'"
  class="p-3 border-round surface-100 mb-3">
  <div class="mb-3">
    <label class="block mb-1 font-semibold">Prodotto da sostituire *</label>
    <div class="flex align-items-center gap-2">
      <span *ngIf="product; else noProduct">{{ product.name }}</span>
      <ng-template #noProduct>
        <span class="grey-text">Nessun prodotto selezionato</span>
      </ng-template>
      <p-button
        [label]="product ? 'Cambia' : 'Scegli prodotto'"
        icon="pi pi-search"
        styleClass="butt p-button-outlined"
        [rounded]="true"
        (onClick)="pickProduct()"></p-button>
    </div>
  </div>
  <div class="mb-3">
    <label class="block mb-1 font-semibold">Seriale *</label>
    <input
      pInputText
      class="w-full"
      [formControl]="serial"
      placeholder="Inserisci il seriale..." />
  </div>
  <div>
    <label class="block mb-1 font-semibold">Ubicazione</label>
    <input
      pInputText
      class="w-full"
      [formControl]="office"
      placeholder="Facoltativa" />
  </div>
</div>

<div class="flex justify-content-between">
  <p-button
    label="Annulla"
    [text]="true"
    styleClass="butt red"
    [rounded]="true"
    (onClick)="cancel()"></p-button>
  <p-button
    label="Continua"
    styleClass="butt"
    [rounded]="true"
    [disabled]="!canConfirm"
    (onClick)="confirm()"></p-button>
</div>
